module.exports = __webpack_public_path__ + "static/media/Icon-brakes.fa85f8c7.svg";